import { memo } from 'react';
// @mui
import { AppBar, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// theme
import { bgBlur } from 'src/theme/css';

// components
import { NavSectionHorizontal } from '../../../components/nav-section-new';
//
import { HeaderShadow } from '../../_common';
import { HEADER } from '../../config-layout';
// import { navAdminConfig, navUserConfig } from './config-navigation';
import { NavSuperAdminConfig, NavSiteAdminConfig, NavOrgAdminConfig, NavIndividualUserConfig, NavOrgUserConfig } from './config-navigation';
import { ROLES } from 'src/utils/constants/constants';

import { useAuthContext } from 'src/auth/hooks';



// ----------------------------------------------------------------------
//

function NavHorizontal() {
  const theme = useTheme();
  const { user } = useAuthContext();

  const renderSwitch = (role: string | undefined) => {
    switch (role) {
      case ROLES.SUPER_ADMIN:
        return NavSuperAdminConfig(user);
      case ROLES.SITE_ADMIN:
        return NavSiteAdminConfig(user);
      case ROLES.ORG_ADMIN:
        return NavOrgAdminConfig(user);
      case ROLES.ORG_USER:
        return NavOrgUserConfig(user);
      case ROLES.INDIVIDUAL_USER:
        return NavIndividualUserConfig(user);
      default:
        return NavSuperAdminConfig(user);
      /*   case ROLES.SUPER_ADMIN:
          return <NavSectionHorizontal data={ConfigNavigation(ROLES.SUPER_ADMIN)} />;
        case ROLES.SITE_ADMIN:
          return <NavSectionHorizontal data={ConfigNavigation(ROLES.SITE_ADMIN)} />;
        case ROLES.ORG_ADMIN:
          return <NavSectionHorizontal data={ConfigNavigation(ROLES.ORG_ADMIN)} />;
        case ROLES.ORG_USER:
          return <NavSectionHorizontal data={ConfigNavigation(ROLES.ORG_USER)} />;
        case ROLES.INDIVIDUAL_USER:
          return <NavSectionHorizontal data={ConfigNavigation(ROLES.INDIVIDUAL_USER)} />;
        default:
          return <NavSectionHorizontal data={ConfigNavigation(ROLES.SUPER_ADMIN)} />; */
    }
  }

  return (
    <AppBar
      component="nav"
      sx={{
        top: HEADER.H_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal data={renderSwitch(user?.role?.name)} config={{ currentRole: user?.role?.name || ROLES.SUPER_ADMIN }} />
        {/* <NavSectionHorizontal data={navData}/> */}
      </Toolbar>

      <HeaderShadow />
    </AppBar >
  );
}

export default memo(NavHorizontal);


// import { memo } from 'react';
// // @mui
// import { useTheme } from '@mui/material/styles';
// import { AppBar, Box, BoxProps, Toolbar } from '@mui/material';
// // config
// import { HEADER } from '../../../config-global';
// // utils
// import { bgBlur } from '../../../utils/cssStyles';
// // components
// import { NavSectionHorizontal } from '../../../components/nav-section';
// //
// import { navAdminConfig, navUserConfig } from './config-navigation';
// import { useAuthContext } from 'src/auth/hooks';

// // ----------------------------------------------------------------------

// function NavHorizontal() {
//   const { user } = useAuthContext();
//   const theme = useTheme();

  // return (
  //   <AppBar
  //     component="nav"
  //     color="transparent"
  //     sx={{
  //       boxShadow: 0,
  //       top: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
  //     }}
  //   >
  //     <Toolbar
  //       sx={{
  //         ...bgBlur({
  //           color: theme.palette.background.default,
  //         }),
  //       }}
  //     >
  //       {user?.role?.name === 'Admin' ? <NavSectionHorizontal data={navAdminConfig} /> : <NavSectionHorizontal data={navUserConfig} />}
  //     </Toolbar>

  //     <Shadow />
  //   </AppBar>
  // );
// }

// export default memo(NavHorizontal);

// // ----------------------------------------------------------------------

// function Shadow({ sx, ...other }: BoxProps) {
//   return (
//     <Box
//       sx={{
//         left: 0,
//         right: 0,
//         bottom: 0,
//         height: 24,
//         zIndex: -1,
//         width: 1,
//         m: 'auto',
//         borderRadius: '50%',
//         position: 'absolute',
//         boxShadow: (theme) => theme.customShadows.z8,
//         ...sx,
//       }}
//       {...other}
//     />
//   );
// }

